import React from 'react';
import { Button, Result } from 'antd';
import { MSALAUTH } from '@/utils/auth';


export const Deactivated: React.FC = () => {
  const handleSignOut = () => {
    MSALAUTH.logOut();
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <Result
        status="403"
        title="Account Deactivated"
        subTitle="Your account has been deactivated. Please contact your administrator to regain access."
        extra={
          <Button type="primary" danger onClick={handleSignOut}>
            Sign Out
          </Button>
        }
      />
    </div>
  );
};

export default Deactivated;
